import { Component } from '@angular/core';

@Component({
  selector: 'app-tanque-no-selected',
  templateUrl: './tanque-no-selected.component.html',
  styleUrls: ['./tanque-no-selected.component.css'],
})
export class TanqueNoSelectedComponent {}
